var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9152 44.2251H39.2957V50.0001H7.18262V44.2251H20.5631V40.5063C16.3201 40.0789 12.2403 38.6404 8.66345 36.3108C5.08665 33.9811 2.11637 30.8277 0 27.1132L4.64836 24.4496C6.28287 27.3152 8.55377 29.7643 11.2847 31.6064C14.0156 33.4486 17.1329 34.6343 20.3947 35.0715C23.6564 35.5087 26.9746 35.1856 30.0917 34.1272C33.2088 33.0689 36.0407 31.3038 38.3676 28.9691C40.6945 26.6344 42.4536 23.793 43.5084 20.6654C44.5632 17.5379 44.8853 14.2085 44.4496 10.9358C44.0138 7.66317 41.9643 3.35552 41.9643 3.35552L46.3892 0.310303C46.3892 0.310303 50 6.02093 50 13.7899C50 27.712 39.4402 39.1611 25.9152 40.5063V44.2251Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4042 0C15.7663 5.1287e-06 9.57446 6.16138 9.57446 13.7618C9.57446 21.3623 15.7663 27.5236 23.4043 27.5236L23.4042 0Z",
    fill: "#256BE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4043 27.5237C31.0422 27.5237 37.234 21.3623 37.234 13.7619C37.234 6.16143 31.0422 5.09598e-05 23.4043 5.02953e-05L23.4043 27.5237Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.209e651483cb9ac0875ecccf5476724a.svg";
export { ForwardRef as ReactComponent };